import React from 'react';
import ContentBannerV3 from '@ajat/design-system/ContentBlocks/ContentBannerV3';
import { ComponentPage, DemoCard } from '../../shared';
import { CONTENT_BANNER_V3 } from './contentDemoData';

export const meta = {
  component: ContentBannerV3,
  title: 'Content Banner V3',
  group: 'Content Blocks',
  importPath: '@ajat/design-system/ContentBlocks/ContentBannerV3',
  figmaNode: '69:19251',
  description:
    'A white band of equal «banner» cells (Crown Student homepage, Figma Crownstudent-MCP 69:19251 / mobile 129:5943): each cell a centred column — title (H3 style), a product photo shown `contain` in a fixed-ratio box (3:1 on desktop, 3:2 on mobile, --radius-card), P.Large copy and a secondary CTA. Two cells side by side from 1024px, stacked on phones; a gray-075 rule separates them — a vertical divider between the columns on desktop, a horizontal one between the stacked cells on mobile, nothing under the block. Every value is a DS token — no component tokens; the ratios and the rule colour are CSS hooks.',
  props: [
    ['items', 'array', '[]', '[{ title, text, image: { src, srcMobile, alt }, ctaLabel, ctaHref, ctaOnClick, ctaVariant }] — one cell each; no image → no photo box, no label → no button; [] renders nothing'],
    ['titleAs', 'elementType', "'h2'", 'Heading element of the cell titles (the style is always typo-h3)'],
    ['className', 'string', "''", 'Additional CSS class on the <section> (other attributes reach it too)'],
  ],
  usage: [
    {
      title: 'On the Crown Student landing',
      code: `import ContentBannerV3 from '@ajat/design-system/ContentBlocks/ContentBannerV3';

<ContentBannerV3
  items={[
    {
      title: 'Designa ditt Champagneglas',
      text: 'Välj att gravera ditt namn och årtal på vårt exklusiva champagneglas.',
      image: { src: glasses, alt: 'Tre graverade champagneglas' },
      ctaLabel: 'Designa Nu!',
    },
    {
      title: 'Kolla in Studentprylar',
      text: 'Då är det bara studentprylarna kvar och sedan kan nedräkningen börja!',
      image: { src: gear, alt: 'Megafon, visselpipa och penna' },
      ctaLabel: 'KOLLA IN!',
      ctaHref: '/editions',
    },
  ]}
/>`,
    },
  ],
};

export default function ContentBannerV3Page() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard
        title="Two cells: photo in a 3:1 box, copy and CTA"
        hint="Figma Crownstudent-MCP 69:19251 · mobile 129:5943 (one cell per row, 3:2 box) · switch the top-bar brand to Crownstudent for the Figma look"
        flush
      >
        <ContentBannerV3 items={CONTENT_BANNER_V3} />
      </DemoCard>
      <DemoCard title="One cell" hint="A lone cell takes the whole row; no label → no button" flush>
        <ContentBannerV3 items={[{ ...CONTENT_BANNER_V3[0], ctaLabel: undefined }]} />
      </DemoCard>
    </ComponentPage>
  );
}
